export const HeaderLinks = ["activityLog","database","userListings","manageAdmin"];
export const AppUrl = ["forgotpassword","forgotpasswordSuccess","setyourPassword"]